module.exports = __webpack_public_path__ + "static/reward_date.702c55b7.svg";